import { gql } from "@apollo/client";

export const getDistributionsListQuery = gql`
    query getDistributionsList(
        $releaseId: Int,
        $limit: Int = 100000,
        $page: Int!
        $cursor: Int
        ) {
            listDistributions(
                releaseId: $releaseId,
                page: $page,
                elementsPerPage: $limit
                cursor: $cursor
        ) {
            posts {
                releaseName
                releaseId
                client {
                    name
                    isApple
                    id
                }
                territory{
                    name
                    id
                }
                logFilePath
                isTakedown
                takedownLogs
                status
                progress
                timestamp
            
                id
                processedOn
                finishedOn
            }
            meta {
                resultCount
                nodeCount
                currentPage
                totalPages
                prevCursor
                nextCursor
            }
        }
    }
`;
